export const environment = {
  production: true,
  buildId: '3875968230723751',
  configFile: 'config.json',
};
